import { Tabs as MuiTabs, styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  width: '100%',
}));

export const StickyTabs = styled(MuiTabs, {
  shouldForwardProp: (prop) => prop !== 'stickyTop',
})<{ stickyTop?: number }>(({ stickyTop = 0, theme }) => ({
  position: 'sticky',
  top: `${stickyTop}px`,
  zIndex: 2,
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}));

export const Content = styled('div')(() => ({
  width: '100%',
  marginTop: '10px',
}));

export const Count = styled('div')(({ theme }) => ({
  height: '18px',
  borderRadius: '4px',
  padding: '0 6px',
  fontSize: '11px !important',
  fontWeight: 700,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.error.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '8px',
}));
